import axios from 'axios'

axios.defaults.baseURL = 'https://addesapi.rendilitros.com/api/';         //prod
//axios.defaults.baseURL = 'http://addesapi.rendilitros.com:50509/api/';      //desarrollo
//axios.defaults.baseURL2 = 'https://localhost:7098/api/';      //desarrollo

axios.defaults.headers.common['Authorization'] = 'Basic QURERVM6QURERXMuMjAyMSRSQ0g=';
